import { DonateButton } from './donate-button';

export const BaseFooter = () => {
  return (
    <div className="flex flex-col justify-between gap-y-4 border-t-2 px-10 py-6 md:flex-row">
      <p className="text-gray-400">© 2025 The Family Dots. All rights reserved.</p>

      <DonateButton />
    </div>
  );
};
